import {
  Drawer as MUIDrawer,
  DrawerProps as MUIDrawerProps,
} from '@mui/material';

export function Drawer({ children, ...props }: MUIDrawerProps) {
  return (
    <MUIDrawer
      {...props}
      sx={{ '& .MuiDrawer-paper': { maxHeight: '100vh' }, ...props.sx }}
    >
      {children}
    </MUIDrawer>
  );
}

export default Drawer;
